import { ModalProvider, PaginationProvider, SearchProvider } from 'dash-ui';

import { GetPropertyByIdQuery } from 'gql/generated.graphql';
import EditAmenityNameInPropertyModal from './components/EditAmenityNameInPropertyModal/EditAmenityNameInPropertyModal';

import FeaturesAndAmenities from './components/FeaturesAndAmenities/FeaturesAndAmenities';
import ManageAmenitiesModal from './components/ManageAmenitiesModal/ManageAmenitiesModal';
import RemoveAmenityModal from './components/RemoveAmenityModal/RemoveAmenityModal';

function PropertyFeaturesAndAmenitiesTab({
  property,
}: {
  property: GetPropertyByIdQuery['getPropertyById'];
}) {
  return (
    <PaginationProvider>
      <SearchProvider>
        <ModalProvider>
          <>
            <FeaturesAndAmenities property={property} />

            <RemoveAmenityModal />
            <ManageAmenitiesModal />
            <EditAmenityNameInPropertyModal />
          </>
        </ModalProvider>
      </SearchProvider>
    </PaginationProvider>
  );
}

export default PropertyFeaturesAndAmenitiesTab;
